import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Divider,
  Drawer,
  Toolbar,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import {
  Brightness4 as MoonIcon,
  Brightness7 as SunIcon,
} from '@material-ui/icons';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
}));

export default function SideMenu({ children }) {
  const classes = useStyles();

  const { palette, toggleDark } = useTheme();

  const darkModeToggler = (
    <ListItem button onClick={toggleDark}>
      <ListItemIcon>
        {palette.type === 'dark' ? <SunIcon /> : <MoonIcon />}
      </ListItemIcon>
      <ListItemText>Toggle Dark Mode</ListItemText>
    </ListItem>
  );

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Toolbar />
      <div className={classes.drawerContainer}>
        {children}
        <Divider />
        {darkModeToggler}
      </div>
    </Drawer>
  );
}
